export const GET_GAME_CONFIGURATION_START = "@gameConfiguration/GET_GAME_CONFIGURATION_START";
export const GET_GAME_CONFIGURATION_SUCCESS = "@gameConfiguration/GET_GAME_CONFIGURATION_SUCCESS";
export const GET_GAME_CONFIGURATION_FAIL = "@gameConfiguration/GET_GAME_CONFIGURATION_FAIL";
export const RESET_STORE = "@gameConfiguration/RESET_STORE";
